/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Company_Registration_Address_PlaceholderInputs */

const en_company_registration_address_placeholder = /** @type {(inputs: Company_Registration_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Company location`)
};

const de_company_registration_address_placeholder = /** @type {(inputs: Company_Registration_Address_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Standort des Unternehmens`)
};

/**
* | output |
* | --- |
* | "Company location" |
*
* @param {Company_Registration_Address_PlaceholderInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const company_registration_address_placeholder = /** @type {((inputs?: Company_Registration_Address_PlaceholderInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Company_Registration_Address_PlaceholderInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_company_registration_address_placeholder(inputs)
	return en_company_registration_address_placeholder(inputs)
});